module.exports = __webpack_public_path__ + "static/media/dev.f5ecec50.png";